"use strict";
var _ = require('underscore');
var SoaModel = require('bunsen/models/SoaModel.js');
var extendCompose = require('bunsen/libraries/extendCompose');
var Anchor = module.exports = extendCompose.call(SoaModel, null, {
    TYPE_ITEM: 'ITEM',
    TYPE_USER: 'USER',
    TYPE_SELLER: 'SELLER',
    TYPE_OFFER: 'OFFER',
    TYPE_SHIPMENT: 'SHIPMENT',
    TYPE_SHIPMENT_QUOTE: 'SHIPMENT_QUOTE',
    TYPE_TRANSACTION: 'TRANSACTION',
    TYPE_PROMOTION: 'PROMOTION',
    TYPE_VERTICAL: 'VERTICAL',
    TYPE_ITEM_LISTING: 'ITEM_LISTING'
});

var isSourceType = function (type) {
    return this.get('sourceType') === type;
};
var ANCHOR_API_TYPE = 'anchor';

Anchor.extendSelf({
    initialize: function (attributes) {
        attributes = attributes || {};
        attributes.apiType = ANCHOR_API_TYPE;
        this.set('apiType', ANCHOR_API_TYPE);
        return Anchor.__super__.initialize.call(this, attributes);
    },
    isPromotion: _.partial(isSourceType, Anchor.TYPE_PROMOTION)
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/Anchor.js
// module id = 12
// module chunks = 62